<app-data-table [title]="title" [columns]="tableColumns" [filters]="tableFilters" [items]="items" [totalCount]="count"
    [page]="page" [pageSize]="pageSize" [loading]="loading" [filterValues]="tableFilterValues" createLabel="Aggiungi"
    [createLink]="['/admin/startups/create']" [rowActions]="rowActions" (pageChange)="handlePageChange($event)"
    (search)="onTableSearch($event)" (delete)="onDelete($event)" (action)="onAction($event)">
</app-data-table>

{{ error }}

<!-- Custom cell templates -->
<ng-template #imageTpl let-startup>
    <img class="img-responsive" [routerLink]="['/admin/startups/edit', startup.id]"
        [src]="'https://api.startupinspire.com/assets/startups/' + startup.id + '/' + startup.startup_logo" />
</ng-template>

<ng-template #nameTpl let-startup>
    <h4 class="p-mb-0 p-mt-0">{{ startup.startup_name }}</h4>
    <p class="small">
        ID: {{ startup.id }} | Likes: {{ startup.likes }} | {{ startup.startup_email }}<br />
        {{ startup.backlink_url }}
    </p>
</ng-template>

<ng-template #statusTpl let-startup>
    <div *ngIf="startup.status == 1" class="dot-green p-mb-10"></div>
    <div *ngIf="startup.status == 0" class="dot-red"></div>
    <ng-container *ngIf="startup.is_featured == 1">
        <p class="small">Featured</p>
    </ng-container>
</ng-template>

<ng-template #backlinkTpl let-startup>
    <div *ngIf="startup.backlink_url" class="dot-green p-mb-10"></div>
    <div *ngIf="!startup.backlink_url" class="dot-red"></div>
</ng-template>

<ng-template #drTpl let-startup>
    <ng-container *ngIf="domainRatings[startup.id] as dr; else drLoadingTpl">
        <span *ngIf="dr.loading" class="pi pi-spin pi-spinner"></span>
        <div *ngIf="!dr.loading && dr.rating !== undefined && dr.rating !== null"
            style="position: relative; width: 44px; height: 44px; display: inline-block;">
            <div [style.width.px]="44" [style.height.px]="44" [style.border-radius]="'50%'"
                [style.background]="getDomainRankGaugeBackground(dr.rating)"
                [style.-webkit-mask]="'radial-gradient(farthest-side, transparent calc(100% - 5px), #000 calc(100% - 5px))'"
                [style.mask]="'radial-gradient(farthest-side, transparent calc(100% - 5px), #000 calc(100% - 5px))'">
            </div>
            <span
                style="position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; font-size: 13px; font-weight: 700; color: #333;">{{
                dr.rating }}</span>
        </div>
        <p-tag *ngIf="!dr.loading && dr.error" severity="danger" value="N/A"></p-tag>
    </ng-container>
    <ng-template #drLoadingTpl>
        <span class="pi pi-spin pi-spinner"></span>
    </ng-template>
</ng-template>